import {
  advanceHsaGroupInput,
  advanceHsaGroupOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/advance-hsa-group";
import { unaryRpc } from "@redotech/rpc/definition";

// Cursor advance. Called when the customer finishes every question in the
// current group. The server walks the flow from rootId, evaluates condition
// nodes against the answer set, and returns the next group (or completion).
export const advanceHsaGroup = unaryRpc({
  name: "advanceHsaGroup",
  input: advanceHsaGroupInput,
  output: advanceHsaGroupOutput,
});
